import { defineMessages } from 'react-intl';

const _default_1: {
	hubStudioLoadingSpinnerLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	hubStudioLoadingSpinnerLabel: {
		id: 'hub-editor.loading-spinner-label',
		defaultMessage: 'Loading hub',
		description: 'Label for the hub editor loading spinner',
	},
});
export default _default_1;
